<template>
  <div class="orderStep flex-row ite-c jus-c">
    <ul class="stepList clearfix" v-if="order_base">
      <li :class="{on:order_base.status_busi != -1, gray:order_base.status_busi == -1}">
        <p class="step-tit">买家下单</p>
        <div class="arc">
          <img :src="(order_base.status_busi == -1) ? gou_gray : gou" alt="">
        </div>
        <p class="step-time">{{order_base.create_time}}</p>
      </li>

      <li :class="{on:(order_base.pay_time || order_base.status_pay == -1), gray:!(order_base.pay_time || order_base.status_pay == -1)}">
        <p class="step-tit">买家付款</p>
        <div class="arc">
          <img :src="gou" alt="" v-if="order_base.pay_time || order_base.status_pay == -1">
          <span v-else>2</span>
        </div>
        <p class="step-time">{{order_base.pay_time}}</p>
      </li>

      <li :class="{on:(order_base.status_logistics == 1 || order_base.status_logistics == 2), gray:!(order_base.status_logistics == 1 || order_base.status_logistics == 2)}">
        <p class="step-tit">商家发货</p>
        <div class="arc">
          <img :src="gou" alt="" v-if="order_base.status_logistics == 1 || order_base.status_logistics == 2">
          <span v-else>3</span>
        </div>
        <p class="step-time">{{order_base.deliver_time}}</p>
      </li>

      <li :class="{on:order_base.finish_time, gray:!order_base.finish_time}">
        <p class="step-tit">订单完成</p>
        <div class="arc">
          <img :src="gou" alt="" v-if="order_base.finish_time">
          <span v-else>4</span>
        </div>
        <p class="step-time">{{order_base.finish_time}}</p>
      </li>

      <li :class="{on:(order_base.close_time && order_base.finish_time), gray:!(order_base.close_time && order_base.finish_time)}">
        <p class="step-tit">订单关闭</p>
        <div class="arc">
          <img :src="gou" alt="" v-if="order_base.close_time">
          <span v-else>5</span>
        </div>
        <p class="step-time">{{ (order_base.status_busi == -1) ? order_base.cancel_time : order_base.close_time}}</p>
      </li>
    </ul>
  </div>
</template>

<script>

  import gou_gray from '@/assets/images/order/gou_gray.png';
  import gou from '@/assets/images/order/gou.png';

  export default {
    name: "orderStep", //物流取卡
    props: {
      orderItem: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        order_base: this.orderItem,
        create_order_time: '',
        send_time: '',
        finish_time: '',
        pay_time: '',
        close_time: '',
        gou_gray: gou_gray,
        gou: gou
      }
    },
    created() {
    },
    watch: {
      orderItem(val) {
        this.order_base = val
      }
    }
  }
</script>

<style scoped>
  .orderStep {
    width: 72%;
    /*min-width: 764px;*/
    background: #fff;
  }

  .stepList li {
    float: left;
    width: 72px;
    font-size: 12px;
    color: #AAAAAA;
    text-align: center;
  }

  .stepList li .step-tit {
    margin-bottom: 8px;
  }

  .stepList li .arc {
    width: 30px;
    height: 30px;
    border: 6px solid #E8E8E8;
    background: #E8E8E8;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    color: #aaa;
    font-size: 17px;
    font-weight: bold;
    line-height: 30px;
    margin: auto;
  }

  .stepList li .step-time {
    margin-top: 14px;
    /*visibility: hidden;*/
  }

  .stepList li + li {
    margin-left: 82px;
  }

  .stepList li + li .arc {
    position: relative;
  }

  .stepList li + li .arc:before {
    content: '';
    position: absolute;
    width: 120px;
    height: 8px;
    background: #E8E8E8;
    top: 50%;
    margin-top: -4px;
    left: -120px;
  }

  .stepList li + li .arc:after {
    content: '';
    position: absolute;
    width: 216px;
    height: 4px;
    background: #f70;
    top: 50%;
    margin-top: -2px;
    left: -128px;
    display: none;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    z-index: 1;
  }

  .stepList li + li .arc img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
  }

  .stepList li:last-child .arc:after {
    width: 128px;
  }

  .stepList li.on .step-tit {
    color: #333;
  }

  .stepList li.on .arc {
    /* background: url("../../../assets/gou.png") no-repeat; */
    background: url("../../../../../../assets/images/order/gou.png") no-repeat;
    color: transparent;
  }

  .stepList li.on .arc:after {
    display: block;
  }

  .stepList li.on .step-time {
    visibility: visible;
  }

  .stepList li.on.gray .arc {
    /* background: url("../../../assets/gou_gray.png") no-repeat; */
    background: url("../../../../../../assets/images/order/gou_gray.png") no-repeat;
  }

  .stepList li.on.gray .arc:after {
    background: #B7B2AF;
    width: 130px;
  }
</style>
